import { VStack, HStack, Text } from "@chakra-ui/react";

const Calendar = ({
  selectedDate,
  setSelectedDate,
  calendarDate,
  isDateOpen,
}) => {
  const calendarDayStyle = {
    w: "13.2%",
    h: "40px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: "700",
    fontSize: "14px",
    lineHeight: "24px",
    fontFamily: "Nunito",
  };
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const year = calendarDate.getFullYear();
  const month = calendarDate.getMonth() + 1;

  function getDaysForMonth() {
    const daysInMonth = new Date(year, month, 0).getDate();
    const firstDayOfMonth = new Date(year, month - 1, 1).getDay();
    const adjustedFirstDay = firstDayOfMonth === 0 ? 6 : firstDayOfMonth - 1;

    let monthData = [];

    let week = new Array(adjustedFirstDay).fill(null);

    for (let i = 1; i <= daysInMonth; i++) {
      week.push({
        day: i,
        date: new Date(year, month - 1, i),
      });
      if (week.length === 7) {
        monthData.push(week);
        week = [];
      }
    }
    if (week.length > 0) {
      while (week.length < 7) {
        week.push(null);
      }
      monthData.push(week);
    }
    return monthData;
  }
  return (
    <VStack width={"100%"} spacing={"1.26%"}>
      {getDaysForMonth().map((week, weekIndex) => (
        <HStack key={weekIndex} width={"100%"} spacing={"1.26%"}>
          {week.map((day, dayIndex) => {
            if (!day) {
              return <Text key={dayIndex} {...calendarDayStyle}></Text>; // Render an empty slot
            }
            const isOpen = isDateOpen(day.day);
            return (
              <Text
                key={dayIndex}
                _hover={{
                  color: isOpen && "#FFFFFF",
                  backgroundColor: isOpen && "#0E3665",
                  cursor: isOpen ? "pointer" : "default",
                }}
                color={
                  selectedDate &&
                  day.date.toDateString() === selectedDate.toDateString()
                    ? "#FFFFFF"
                    : "#088041"
                }
                backgroundColor={
                  selectedDate &&
                  day.date.toDateString() === selectedDate.toDateString()
                    ? "#0E3665"
                    : !isOpen ? "#eceff9" : "rgba(13, 227, 115, 0.1)"
                }
                {...calendarDayStyle}
                onClick={() => { isOpen && setSelectedDate(day.date); }}
              >
                {day.day}
              </Text>
            );
          })}
        </HStack>
      ))}
    </VStack>
  );
};

export default Calendar;
